import { damageControlStrict } from "@/api/damageControl";
import { completionBlockers } from "@/utils/damageControlReview";

// REQ-11: completion is scoped to the booking's CURRENT car and side.
// AI outcomes and warnings never enable strict mode or override a completed inspection.
export function strictBlock({ company, booking, side, inspections = [], inspection = null }) {
  const allowed = { blocked: false, reasons: [] };
  if (!damageControlStrict(company)) return allowed;
  const carId = booking && booking.car_id;
  const records = [...inspections, ...(inspection ? [inspection] : [])];
  const matches = item => carId != null && item.car_id === carId && item.side === side;
  if (records.some(item => matches(item) && item.status === "completed")) return allowed;

  let reasons = [];
  if (inspection && matches(inspection) && inspection.status === "in_progress") {
    reasons = completionBlockers(inspection);
    if (!reasons.length) reasons = [{ reason: "damage_control.strict.incomplete" }];
  } else if (records.some(item => matches(item) && item.status === "in_progress")) {
    reasons = [{ reason: "damage_control.strict.incomplete" }];
  } else if (records.some(item => item.side === side && item.car_id !== carId)) {
    reasons = [{ reason: "damage_control.strict.current_car" }];
  } else {
    reasons = [{ reason: "damage_control.strict.no_inspection" }];
  }
  return { blocked: true, reasons };
}
